import { Tooltip } from "@mui/material";
import {
  DISPLAY_DATE_TOOLTIP,
  DISPLAY_DATETIME_TOOLTIP,
  formatDisplayDate,
  formatDisplayDateTime,
} from "utils/dateFormat";

const hasValue = (value) => value !== null && value !== undefined && value !== "";

export function DisplayDate({ value, fallback = "—", className, showTooltip = true }) {
  const text = formatDisplayDate(value, fallback);
  if (!showTooltip || !hasValue(value) || text === fallback) {
    return <span className={className}>{text}</span>;
  }
  return (
    <Tooltip title={DISPLAY_DATE_TOOLTIP}>
      <span className={className}>{text}</span>
    </Tooltip>
  );
}

export function DisplayDateTime({ value, fallback = "—", className, showTooltip = true }) {
  const text = formatDisplayDateTime(value, fallback);
  if (!showTooltip || !hasValue(value) || text === fallback) {
    return <span className={className}>{text}</span>;
  }
  return (
    <Tooltip title={DISPLAY_DATETIME_TOOLTIP}>
      <span className={className}>{text}</span>
    </Tooltip>
  );
}

export default DisplayDate;
